module.exports = __webpack_public_path__ + "static/img/banner5.da67980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_aboutus/banner5.png
// module id = cea7
// module chunks = 1